// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/registry.npmjs.org/css-loader/3.6.0_webpack@4.43.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.svelte-5jhg9v{display:grid;grid-template-columns:1fr 100fr;align-items:first baseline;grid-column-gap:1em;margin-bottom:1em}", ""]);
// Exports
module.exports = exports;
